import { render, staticRenderFns } from "./SswgNav.vue?vue&type=template&id=0b0c135a&scoped=true"
import script from "./SswgNav.vue?vue&type=script&lang=js"
export * from "./SswgNav.vue?vue&type=script&lang=js"
import style0 from "./SswgNav.vue?vue&type=style&index=0&id=0b0c135a&prod&lang=scss&scoped=true"
import style1 from "./SswgNav.vue?vue&type=style&index=1&id=0b0c135a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c135a",
  null
  
)

export default component.exports